export const DEFAULT_COLOR_PALETTE = [
    '#c5c5c5',
    '#ff878a',
    '#fea06a',
    '#f7bd51',
    '#f6d861',
    '#c3e684',
    '#85d7a2',
    '#77d3e9',
    '#a1e7dd',
    '#79abff',
    '#b8acff',
    '#e39ef2',
    '#faaee9',
    '#ff95c9',
    '#ffafc1',
    '#aaa',
]
